$(document).ready(function () {
  $(".mak_review-scroll").slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: "280px",
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  });
  $(".smooth").slick({
    slidesToShow: 3.75,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    arrows: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3.25,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  });
});

window.onload = function () {
  var londonButton = document.getElementById("londonButton"),
    descriptionContent = document.getElementById("description");
  descriptionContent.textContent.trim() === "" &&
    (londonButton.style.display = "none");
};
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  for (
    tabcontent = document.getElementsByClassName("tabcontent"), i = 0;
    i < tabcontent.length;
    i++
  )
    tabcontent[i].style.display = "none";
  for (
    tablinks = document.getElementsByClassName("tablinks"), i = 0;
    i < tablinks.length;
    i++
  )
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  (document.getElementById(cityName).style.display = "block"),
    (evt.currentTarget.className += " active");
}
// Select all collapsible buttons
var coll = document.querySelectorAll(".cma-collapsible");

// Loop through each collapsible button
for (let i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    var mycontnt = this.parentElement.nextElementSibling; // Get the corresponding content
    var svg = this.querySelector(".mak-plus"); // Get the SVG icon

    // Collapse all other contents
    for (let j = 0; j < coll.length; j++) {
      var content = coll[j].parentElement.nextElementSibling;
      var icon = coll[j].querySelector(".mak-plus");

      if (content !== mycontnt && content.style.maxHeight) {
        content.style.maxHeight = null;
        icon.style.transform = "";
        coll[j].classList.remove("active");
      }
    }

    // Toggle the clicked content
    this.classList.toggle("active");

    if (mycontnt.style.maxHeight) {
      mycontnt.style.maxHeight = null; // Collapse if already expanded
      svg.style.transform = "";
    } else {
      mycontnt.style.maxHeight = mycontnt.scrollHeight + "px"; // Expand if collapsed
      svg.style.transform = "rotate(180deg)";
    }
  });
}
$(document).ready(function () {
  // Click event handler for video thumbnails
  $(".video-thumbnail").click(function () {
    var videoSrc = $(this).data("video");
    var posterSrc = $(this).data("poster");

    // Set video source and poster in modal
    $("#modal-video").attr("src", videoSrc);
    $("#modal-video").attr("poster", posterSrc);

    // Show the modal
    $("#video-modal").css("display", "block").css("opacity", "1");
  });

  // Click event handler for closing the modal
  $(".mak-close").click(function () {
    // Pause the video
    $("#modal-video").get(0).pause();

    // Reset video source to prevent audio still playing in some browsers
    $("#modal-video").attr("src", "");

    // Hide the modal
    $("#video-modal").css("display", "none");
  });

  // Close modal if user clicks outside of the modal content
  $(document).click(function (event) {
    if (
      $(event.target).closest(".modal-content").length === 0 &&
      $(event.target).closest(".video-thumbnail").length === 0
    ) {
      $("#modal-video").get(0).pause();
      $("#modal-video").attr("src", ""); // Reset video source
      $("#video-modal").css("display", "none");
    }
  });
});
$(document).ready(function () {
  $(".reel-scroll").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1,
    speed: 6000,
    dots: false,
    arrows: false,
    cssEase: "linear",
    waitForAnimate: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1430,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
